export const PAYMENT_METHOD_OPTIONS = [
    { id: 3, name: 'Оплата перечислением на счёт' },
    { id: 2, name: 'Оплата наличными' },
    { id: 4, name: 'Платежи на Kaspi.kz' },
]

export const PAYMENT_METHOD_OPTIONS_INTRACITY = [
    { id: 3, name: 'Оплата перечислением на счёт' },
    { id: 4, name: 'Платежи на Kaspi.kz' },
]

export const PAYMENT_METHOD_PAYER_OPTIONS = [{ id: 3, name: 'Оплата перечислением на счёт' }]

export const SHIPMENT_TYPES = [
    { id: 1, name: 'Авто' },
    { id: 2, name: 'Авиа' },
]

export const CITY_SHIPMENT_TYPES = [{ id: 1, name: 'Авто' }]

export const LTL_SHIPMENT_TYPES = [
    { id: 1, name: 'Авто' },
    { id: 2, name: 'Авиа' },
    { id: 4, name: 'Проекты' },
]

export const PAYMENT_TYPE_OPTIONS = [
    { id: 1, name: 'Оплата отправителем' },
    { id: 2, name: 'Оплата получателем' },
    { id: 3, name: 'Оплата третьим лицом' },
]

export const LOADING_TYPE_OPTIONS = [
    { id: 'sideway', name: 'Боковая' },
    { id: 'top', name: 'Верхняя' },
    { id: 'backward', name: 'Задняя' },
]

export const LOAD_CAPACITY_OPTIONS = [
    { id: 1, name: '1.5 тонны' },
    { id: 2, name: '3 тонны' },
    { id: 3, name: '5 тонн' },
    { id: 4, name: '7 тонн' },
    { id: 5, name: '10 тонн' },
    { id: 6, name: '20 тонн' },
]

export const PAYMENT_METHODS_OBJECT = {
    '3': 'Оплата перечислением на счёт',
    '2': 'Оплата наличными',
}

export const SHIPMENT_TYPES_OBJECT = {
    '1': 'Авто',
    '2': 'Авиа',
}

export const LTL_SHIPMENT_TYPES_OBJECT = {
    '1': 'Авто',
    '2': 'Авиа',
    '4': 'Проекты',
}

export const PAYMENT_TYPES_OBJECT = {
    '1': 'Оплата отправителем',
    '2': 'Оплата получателем',
}

export const TRANSPORT_TYPES = [
    { id: 1, name: 'Цельнометаллический' },
    { id: 2, name: 'Тент' },
    { id: 3, name: 'Автовоз' },
    { id: 4, name: 'Эвакуатор' },
    { id: 5, name: 'Кран' },
    { id: 6, name: 'Манипулятор' },
    { id: 7, name: 'Трал' },
]
